import EnterpriseObjectMemberMetadata from "../../EnterpriseObjectMemberMetadata";
import EnterpriseObjectMetadata from "../../EnterpriseObjectMetadata";

class ETLGoogleConfigurationEnterpriseObjectMetadata extends EnterpriseObjectMetadata {

    constructor() {
        super();

        this.name = "ETLGoogleConfiguration";
        this.primaryEnterpriseComponent = "ETLGoogleConfiguration";

        let eom: EnterpriseObjectMemberMetadata = new EnterpriseObjectMemberMetadata();
        eom.name = "ETLGoogleConfiguration";
        eom.enterpriseComponent = "ETLGoogleConfiguration";
        eom.relationship = undefined;
        this.enterpriseComponentMembers.set(eom.name, eom);

        eom = new EnterpriseObjectMemberMetadata();
        eom.name = "ETLGoogleConfigurationDetail";
        eom.enterpriseComponent = "ETLGoogleConfigurationDetail";
        eom.relationship = "ETLGoogleConfigurationETLGoogleConfigurationDetail";
        this.enterpriseComponentMembers.set(eom.name, eom);

    }
}

export default ETLGoogleConfigurationEnterpriseObjectMetadata;